<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Session Expiration</p>
        </header>
        <section class="modal-card-body">
            <p>Your session is about to expire</p>
        </section>
        <footer class="modal-card-foot">
            <button class="is-pulled-right button is-primary" type="button" @click="doRefresh()">Keep Me Logged In</button>
            <button class="is-pulled-right button is-info" type="button" @click="doLogout()">It's OK I'm done!</button>
        </footer>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import addSeconds from "date-fns/add_seconds"
export default {
  name: 'SessionRefresh',
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'base_url', 'token'
    ])
  },
  methods: {
    doRefresh(){
      this.$parent.close();
      axios.post(`${this.base_url}token/refresh/`, {token: this.token} )
        .then(response => {
          console.log('response ', response.data)
          const token_expiry = addSeconds(new Date(), 86400); //1 day
          response.data['token_expiry'] = token_expiry;
          this.$store.dispatch('refresh_token', response.data);
        })
        .catch(error => {
          console.log('error ', error.response.data)
          this.$toast.open({
            duration: 5000,
            message: 'Valchrom failed to keep your session active',
            position: 'is-top',
            type: 'is-danger'
          })
        });
    },
    doLogout() {
      this.$parent.close()
      axios.post(`${this.base_url}accounts/logout/`)
        .then(() => {
          window.localStorage.removeItem('valchrom-token');
          window.localStorage.removeItem('valchrom-token-expiry');
          window.localStorage.removeItem('valchrom-user');
          this.$store.dispatch('logout');
          this.$router.push({path: '/'});
        })
        .catch(() => {})
    }
    
  }
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
</style>
